module.exports = __webpack_public_path__ + "static/media/Feedmanufacturing_.b79294d1.jpg";